import request from '../../utils/request'

// 查询所有类型
export function fetchAll (templateId) {
  return request.get(`/template/parameter/type/all?tid=${templateId}`)
}

// 创建类型
export function create (data) {
  return request.post('/template/parameter/type/create', data)
}

// 修改类型
export function updateById (data) {
  return request.post('/template/parameter/type/updateById', data)
}

// 删除类型
export function deleteById (id) {
  return request.get(`/template/parameter/type/delete/${id}`)
}
